var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 701,
    height: 439,
    viewBox: "0 0 701 439",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 697,
    height: 435,
    rx: 22,
    fill: "#FAFAFA",
    fillOpacity: 0.980392
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 697,
    height: 435,
    rx: 22,
    stroke: "#007086",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319.354 265.15V175.849C319.356 174.732 319.658 173.636 320.229 172.675C320.801 171.715 321.62 170.926 322.6 170.391C323.581 169.856 324.688 169.595 325.805 169.634C326.921 169.674 328.007 170.013 328.947 170.617L398.415 215.255C399.294 215.818 400.018 216.594 400.519 217.511C401.021 218.427 401.283 219.455 401.283 220.5C401.283 221.545 401.021 222.572 400.519 223.489C400.018 224.405 399.294 225.181 398.415 225.745L328.947 270.395C328.007 270.999 326.921 271.338 325.805 271.378C324.688 271.418 323.581 271.156 322.6 270.621C321.62 270.086 320.801 269.297 320.229 268.337C319.658 267.377 319.356 266.28 319.354 265.163V265.15Z",
    fill: "#007086"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M396.252 218.62L396.257 218.623C396.572 218.825 396.831 219.102 397.01 219.43C397.189 219.758 397.283 220.126 397.283 220.5C397.283 220.874 397.189 221.241 397.01 221.57C396.831 221.897 396.572 222.175 396.257 222.377L396.252 222.38L326.787 267.029C326.45 267.245 326.062 267.366 325.662 267.38C325.263 267.395 324.867 267.301 324.516 267.11C324.165 266.918 323.872 266.636 323.667 266.292C323.463 265.949 323.355 265.558 323.354 265.159V265.15V175.853C323.355 175.454 323.463 175.063 323.667 174.72C323.872 174.376 324.165 174.094 324.516 173.903C324.867 173.711 325.263 173.618 325.663 173.632C326.062 173.646 326.45 173.767 326.786 173.983C326.786 173.983 326.787 173.983 326.787 173.983L396.252 218.62Z",
    stroke: "#FAFAFA",
    strokeOpacity: 0.980392,
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M213.458 220.5C213.458 144.816 274.816 83.4585 350.5 83.4585C426.184 83.4585 487.542 144.816 487.542 220.5C487.542 296.185 426.184 357.542 350.5 357.542C274.816 357.542 213.458 296.185 213.458 220.5ZM350.5 102.146C319.111 102.146 289.007 114.615 266.811 136.811C244.615 159.007 232.146 189.111 232.146 220.5C232.146 251.89 244.615 281.993 266.811 304.189C289.007 326.385 319.111 338.854 350.5 338.854C381.89 338.854 411.993 326.385 434.189 304.189C456.385 281.993 468.854 251.89 468.854 220.5C468.854 189.111 456.385 159.007 434.189 136.811C411.993 114.615 381.89 102.146 350.5 102.146Z",
    fill: "#007086"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M217.458 220.5C217.458 147.025 277.025 87.4585 350.5 87.4585C423.975 87.4585 483.542 147.025 483.542 220.5C483.542 293.975 423.975 353.542 350.5 353.542C277.025 353.542 217.458 293.975 217.458 220.5ZM350.5 98.146C318.05 98.146 286.928 111.037 263.983 133.983C241.037 156.929 228.146 188.05 228.146 220.5C228.146 252.951 241.037 284.072 263.983 307.018C286.928 329.963 318.05 342.854 350.5 342.854C382.95 342.854 414.072 329.963 437.018 307.018C459.963 284.072 472.854 252.951 472.854 220.5C472.854 188.05 459.963 156.929 437.018 133.983C414.072 111.037 382.95 98.146 350.5 98.146Z",
    stroke: "#FAFAFA",
    strokeOpacity: 0.980392,
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.d84693f22ef67d4f4c8632b800f77ae0.svg";
export { ForwardRef as ReactComponent };